/** @jsxImportSource @emotion/react */
import React from 'react'
import { PortofolioForm, PortofolioPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/PortofolioContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, portofolioManagement } = breadcrumbItems

const PortofolioCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <PortofolioForm />
        </div>
        <div css={styles.right}>
          <PortofolioPreview />
        </div>
      </div>
    </Provider>
  )
}

export default PortofolioCreate;
